import { useMemo } from 'react';
import { useRole } from '@/hooks/useRole';
import { getFilteredMenuItems } from '@/config/menuConfig';

export const useMenuItems = () => {
  const roleUtils = useRole();

  const menuItems = useMemo(() => {
    return getFilteredMenuItems(roleUtils);
  }, [roleUtils]);

  return menuItems;
};
